import Combobox from '../Combobox.jsx';
import { formatTime, parseTime } from '../../lib/DateTime.js';
import { useMemo } from 'react';

function absMinute(time) {
    const parts = time.split(':', 2);
    return parseInt(parts[0]) * 60 + parseInt(parts[1]);
}

const TimeOfDayInput = ({ value, onChange, maxValue, minValue }) => {
    let thisTimeOptions = useMemo(() => {
        const timeOptions = [];

        for (let hour = 0; hour < 24; hour++) {
            for (let minute = 0; minute < 60; minute += 5) {
                const rawTime =
                    (hour + '').padStart(2, '0') +
                    ':' +
                    (minute + '').padStart(2, '0');
                const displayTime = formatTime(parseTime(rawTime));
                timeOptions.push({
                    key: rawTime,
                    label: displayTime,
                });
            }
        }

        return timeOptions;
    }, []);

    // if (maxValue) {
    //     thisTimeOptions = thisTimeOptions.filter(opt => opt.key < maxValue);
    // }

    // if (minValue) {
    //     thisTimeOptions = thisTimeOptions.filter(opt => opt.key > minValue);
    // }

    // If there's a min value and no max, then we can show the duration
    if (minValue && !maxValue) {
        const startMinute = absMinute(minValue);
        thisTimeOptions = thisTimeOptions.map(opt => {
            let diff = absMinute(opt.key) - startMinute;
            if (diff < 0) {
                // It's wrapping to the next day!
                diff += 60 * 24;
            }
            const diffMinutes = diff % 60;
            const diffHours = Math.floor(diff / 60);

            let duration = '';
            if (diffHours) {
                duration += `${diffHours} hr${diffHours > 1 ? 's' : ''}`;
            }
            if (diffMinutes) {
                duration += `${diffHours ? ' ' : ''}${diffMinutes}min`;
            }

            return {
                ...opt,
                description: `(${duration})`,
            };
        });
    }

    return (
        <Combobox
            value={value}
            onChange={onChange}
            options={thisTimeOptions}
            className="w-32"
            optionsClassName="!w-56"
            filter={(label, query) => {
                query = query.toLowerCase().replace(' ', '');
                const isAm = query.includes('a');
                const isPm = query.includes('p');
                const includeMinutes = query.includes(':');
                if (!includeMinutes) {
                    const hour = parseInt(query);
                    return label
                        .toLowerCase()
                        .includes(
                            `${hour}:00${isAm ? 'am' : isPm ? 'pm' : ''}`,
                        );
                } else {
                    return label.toLowerCase().includes(query.toLowerCase());
                }
            }}
        />
    );
};

export default TimeOfDayInput;
